import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { useDebouncedCallback } from "use-debounce/lib";
import { debounceSearchFilterDelay } from "../../util/config";
import { useLazyQuery } from "@apollo/client";
import { GQL_COMUNI } from "../../apollo/query/location";
import IntlMessages from "../../util/IntlMessages";

const ComuneInput = ({ queryFilter, onChange, onSelect, value, ...rest }) => {
   let [loadingData, { loading, data }] = useLazyQuery(GQL_COMUNI, {
      fetchPolicy: "cache-first",
   });

   const [selectedComune, setSelectedComune] = useState(null);

   const [results, setResults] = useState([]);

   const fetchData = (
      term = "",
      initialValue = null,
      sorting = { key: "created_at", direction: -1 },
      limit = 20
   ) => {
      let filter = {
         description: `${term}%`,
         ...queryFilter,
      };

      if (initialValue) {
         filter.code = initialValue;
      }

      loadingData({
         variables: {
            filter: filter,
            sorting,
            limit,
         },
      });
   };

   const debouncedFilterCallback = useDebouncedCallback(
      (term) => fetchData(term),
      debounceSearchFilterDelay
   );

   useEffect(() => {
      //init query
      fetchData("", value);
   }, [value]);

   useEffect(() => {
      if (data && data.comuni?.data) {
         if (value) {
            const selectedComuneInResult = data.comuni?.data.find(
               (c) => c.code === value
            );
            if (selectedComuneInResult) {
               //il value può cambiare dall'esterno (es. componente rimasto montato): aggiorna le opzioni se non lo contengono
               setSelectedComune(selectedComuneInResult);
               if (!results.some((c) => c.code === value)) {
                  setResults(data.comuni.data);
               }
            } else if (selectedComune?.code === value) {
               setResults(data.comuni.data.concat(selectedComune));
            } else {
               setResults(data.comuni.data);
            }
         } else {
            setResults(data.comuni.data);
         }
      }
   }, [data]);

   return (
      <Select
         loading={loading}
         showSearch={true}
         defaultActiveFirstOption={false}
         allowClear={false}
         showArrow={true}
         filterOption={false}
         onSearch={(term) => debouncedFilterCallback(term)}
         onSelect={onSelect}
         onChange={(value, option) => {
            onChange(value, option);
         }}
         placeholder={<IntlMessages id="common.search" />}
         notFoundContent={null}
         value={!loading ? value : null}
         {...rest}
      >
         {results.map((c) => {
            return (
               <Select.Option key={c.id} value={c.code} province={c.province}>
                  {`${c.description} (${c.province.code})`}
               </Select.Option>
            );
         })}
      </Select>
   );
};

ComuneInput.defaultProps = {
   queryFilter: {},
};

export default ComuneInput;
